
export const SET_CONTRACT_PARTIES = "SET_CONTRACT_PARTIES";
export function action_setContractParties(obj, flag) {
	return { type: SET_CONTRACT_PARTIES, payload: {parties: obj, fireSet: flag}};
}

export const SET_FIRE_SET_CONTRACT_PARTIES = "SET_FIRE_SET_CONTRACT_PARTIES";
export function action_setFireContractParties(obj) {
	return { type: SET_FIRE_SET_CONTRACT_PARTIES, payload: obj };
}

export const SET_FIRE_SET_BOOK = "SET_FIRE_SET_BOOK";
export function action_setFireBook(obj) {
	return { type: SET_FIRE_SET_BOOK, payload: obj };
}